/*
 * Adaptive mega menu — pure layout decision.
 *
 * No DOM access. Shared by the browser custom element (assets/mega-menu.js)
 * and the unit tests (test/mega-menu-layout.test.js).
 *
 * Columns:  [ rail (mid-level menu) | subitems | promos ]
 *
 * The promos take one of four arrangements, narrowest-saving as the subitems
 * get squeezed. Compacted promos are ALWAYS stacked vertically (that is the
 * point of compacting — to save horizontal width):
 *
 *   block    full blocks in a single row                       (width: N blocks)
 *   tail     (N-2) full blocks + the last 2 as compact cards
 *            stacked vertically in one column                  (width: N-1 blocks)
 *   compact  compact cards in a 2-column grid (2x2 for four)    (width: 2 blocks)
 *   stack    compact cards in a single column                  (width: 1 block)
 *
 * Returns: { compact, promoCard: 'none'|'block'|'tail'|'compact'|'stack' }
 */
(function () {
  function decideLayout(opts) {
    var rem = opts.rem || 10;
    var mode = opts.mode || 'auto';
    var avail = opts.avail;
    var n = opts.categoryCount;
    var p = opts.promoCount;

    var BLOCK = 21 * rem; // a promo column is one block wide (compact cells too)
    var GAP = 2 * rem; // gap between promo columns
    var SEP = 4 * rem; // gap + divider before the promo area
    var RAIL = 23 * rem; // compact rail width
    var MINCOL = 16.5 * rem; // min spacious category-column width
    var COLGAP = 3.2 * rem; // gap between spacious columns
    var minSub = opts.longestSub + 2 * rem; // subitem column must fit the longest label

    var rowBlock = p * BLOCK + Math.max(0, p - 1) * GAP; // N blocks across
    var tailW = Math.max(0, p - 1) * BLOCK + Math.max(0, p - 2) * GAP; // N-1 columns
    var grid2 = 2 * BLOCK + GAP; // 2 columns
    var catsMin = n * MINCOL + Math.max(0, n - 1) * COLGAP;

    // Best promo arrangement given the left side (categories or rail) takes
    // `left` px; promos get whatever horizontal room is left.
    function promoCardFor(left) {
      if (p <= 0) return 'none';
      var room = avail - left - SEP;
      if (room >= rowBlock) return 'block';
      if (p >= 3 && room >= tailW) return 'tail';
      if (room >= grid2) return 'compact';
      return 'stack';
    }

    var spaciousPromo = promoCardFor(catsMin); // promos beside full category columns
    var compactPromo = promoCardFor(RAIL + minSub); // promos beside rail + detail

    // Stay spacious (full category columns + subitems, no rail) as long as the
    // columns fit AND the promos don't get squeezed into a tall single stack.
    // Otherwise collapse to the rail, which frees width for the promos.
    var spaciousViable = avail >= catsMin && (p === 0 || spaciousPromo !== 'stack');

    var compact;
    if (mode === 'spacious') compact = false;
    else if (mode === 'compact') compact = true;
    else compact = !spaciousViable;

    return { compact: compact, promoCard: compact ? compactPromo : spaciousPromo };
  }

  var api = { decideLayout: decideLayout };
  if (typeof window !== 'undefined') window.MegaMenuLayout = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})();
